import { render, staticRenderFns } from "./DocsMenuList.vue?vue&type=template&id=70f2d628&"
import script from "./DocsMenuList.vue?vue&type=script&lang=js&"
export * from "./DocsMenuList.vue?vue&type=script&lang=js&"
import style0 from "./DocsMenuList.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports